import { RequestorModel } from '../shopping-cart/requestor-model.model';

export class JsonPostModel {
  userId: string;
  // intakeChangeRequests: JsonRequestModel[];
  addpTdp: string = 'false';
  requestorEmail: string;
  requestorFaxNo: string;
  requestorFaxRegion: string;
  requestorFullName: string;
  requestorPhoneNo: string;
  requestorPhoneRegion: string;
  recaptchaToken: string;
  signature: string;

  constructor(requestor: RequestorModel) {
    this.userId = 'pifria';

    if ((document && document.referrer) &&
      (document.referrer.includes('.uccitdp.com') ||
      document.referrer.includes('.addp-ucci.com'))) {
        
      this.addpTdp = 'true';
    }

    this.recaptchaToken = requestor.contactCapcha;
    this.requestorEmail = requestor.contactEmail;
    this.requestorFaxNo = requestor.contactFax;
    this.requestorFaxRegion = requestor.requestorFaxRegion;
    this.requestorFullName = requestor.contactFullName;
    this.requestorPhoneNo = requestor.contactPhone;
    this.requestorPhoneRegion = requestor.requestorPhoneRegion;
    this.signature = requestor.contactSignature ? requestor.contactSignature.toString() : null;
  }
}
